<template>
  <div class="modal-wrapper" @click.stop="$emit('close')">
    <div class="modal" @click.stop>
      <slot name="header"/>
      <slot name="main"/>
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal'
}
</script>

<style lang="scss" scoped>
  .modal-wrapper {
    width: 100%;
    height: 100vh;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(10, 10, 20, 0.8);
  }

  .modal {
    max-width: 95%;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: #FFFFFF;
    border-radius: 20px;
  }
</style>